import { Component, OnInit, Output, EventEmitter } from '@angular/core'
import { AngularCsv } from 'angular7-csv'
import { RequestsService } from '../../../_shared/services/requests.service'
import * as moment from 'moment'

declare var jQuery: any

@Component({
  selector: 'app-new-market-info-design',
  templateUrl: './new-market-info-design.component.html',
  styleUrls: ['./new-market-info-design.component.scss'],
})
export class NewMarketInfoDesignComponent implements OnInit {
  @Output() successEvent = new EventEmitter()
  @Output() successMessage = new EventEmitter()

  constructor(private RequestService: RequestsService) {}

  page = 1
  count = 10
  loading = false
  districtOption: string
  inputs = []
  cropDetails = []
  openSuccessModal = false
  addRecordSuccess = false
  marketInfo = []
  selectedCrop: string
  selectedCropRecord: object
  message = null
  errors = null
  InputId = null
  inputDelete: object
  openAddModal = false
  openEditModal = false
  openDeleteModal = false
  success = false
  selectedCsv: File = null
  selectedCrops: any
  selectCrop = []
  districts: any
  searchItem: string
  selectedCropName: string
  valueEdit: string
  filteredItems = []
  editIsSuccess = false
  newRecordInput: object
  serverError = false

  handleFileSelect($event) {
    this.selectedCsv = $event.target.files[0]
  }
  ngOnInit() {
    this.reloadInput()
  }

  getAllInput(district): void {
    this.loading = true
    const url = `market-info/${district}`
    this.RequestService.dash_get(url, null).subscribe((response) => {
      const latestDateInMs = Math.max(
        ...this.dateToMilliseconds(response.dates)
      )
      const latestDateString = moment(
        new Date(latestDateInMs).toString()
      ).format('YYYY-MM-DD')
      const avgSet = response.avg_results
      this.marketInfo = response.mkt_info
      this.loading = false
      let crops = []
      // console.log(latestDateString);
      avgSet[latestDateString].forEach((item) => {
        // item['avg_retail'] = Number(item['avg_retail']).toLocaleString();
        // item['avg_wholesale'] = Number(item['avg_wholesale']).toLocaleString();
        this.inputs.push(item)
        this.filteredItems.push(item)
        crops.push({ label: item.crop, value: item.crop })
        // console.log(item);
      })

      this.selectCrop = crops.filter(
        (value, index, array) =>
          !array.filter(
            (v, i) => JSON.stringify(value) == JSON.stringify(v) && i < index
          ).length
      )
      // this.inputs = response.avg_results[latestDateString];
      // console.log('result: ' + JSON.stringify(response.avg_results));
      // console.log('latest-date: ' + JSON.stringify(latestDateString));
    })
  }

  dateToMilliseconds(dateArray) {
    const dateMilliseconds = []
    dateArray.forEach((element) => {
      dateMilliseconds.push(Date.parse(element))
    })
    return dateMilliseconds
  }
  reloadInput() {
    this.getAllInput('all')
    this.getAllDistricts()
  }

  getAllDistricts() {
    this.loading = true
    const url = 'districts-subcounties'
    this.RequestService.dash_get(url, null).subscribe((response) => {
      this.districts = response.districts
    })
  }

  FilterDataByDistrict() {
    this.districtOption = jQuery('#district').val()
    this.inputs = []
    // console.log(this.districtOption);
    this.getAllInput(this.districtOption)
  }

  filterItemFunction() {
    this.searchItem = jQuery('#searchItem').val()
    // console.log(this.inputs);
    this.filteredItems = this.inputs.filter(
      (input) =>
        input.crop.toLowerCase().indexOf(this.searchItem.toLowerCase()) !== -1
    )
    // console.log(this.searchItem);
  }

  uploadMarketInfo() {
    if (this.selectedCsv) {
      this.loading = true
      const URL = `dashboard/uploadMarketInfo`
      let formData = new FormData()
      formData.append('csv', this.selectedCsv, this.selectedCsv.name)
      this.RequestService.dash_putWithImage(URL, formData).subscribe(
        (response) => {
          this.loading = false
          this.message = response.message
          this.openSuccessModal = true
          window.location.reload()
        },
        (error) => this.catchError(error)
      )
    } else {
      this.errors = 'You Must Attch A csv File'
    }
  }
  catchError(errorResponse) {
    this.loading = false
    const { error } = errorResponse
    return (this.errors = error.error)
  }

  downloadList() {
    let selectedItems = []
    const today = moment(new Date()).format('YYYY-MM-DD')
    this.inputs.map((item) => {
      selectedItems.push({
        crop: item.crop,
        avg_retail: item.avg_retail,
        avg_wholesale: item.avg_wholesale,
        date: moment(item.date).format('MMM DD,YYYY'),
      })
    })
    // console.log('selected-rows: ', selectedItems);
    let options = {
      // fieldSeparator: ',',
      // quoteStrings: '"',
      // decimalseparator: '.',
      // showLabels: true,
      // showTitle: true,
      // title: 'Your title',
      // useBom: true,
      noDownload: false,
      headers: [
        'Item',
        'Average Retail Price',
        'Average Wholesale Price',
        'Expected Delivery',
      ],
    }
    const filename = 'market prices' + '_PO_' + today.replace(/-/g, '_')
    new AngularCsv(selectedItems, filename, options)
  }

  viewDetails(crop: string): void {
    // console.log('crop-selected: ' + crop);
    this.selectedCropName = crop
    this.marketInfo.forEach((item) => {
      if (item['commodity'] === crop) {
        this.cropDetails.push(item)
      }
    })
  }
  prepareToDeleteMarketPrice(data: object) {
    this.inputDelete = data
    this.openAddModal = false
    this.openEditModal = false
    this.openSuccessModal = false
    this.openDeleteModal = true
  }

  deleteMarketPrice(id) {
    this.InputId = null
    this.loading = true
    this.RequestService.dash_delete(id, 'dashboard/dropRecord').subscribe(
      (response) => {
        this.loading = false
        this.success = true
        this.message = response.message
        // load modal
        this.openEditModal = false
        this.openDeleteModal = false
        this.openAddModal = false
        this.openSuccessModal = true
        this.reloadInput()
        window.location.reload()
      },
      (errorResponse) => {
        this.loading = false
        const { error } = errorResponse
        return (this.errors = error.error)
      }
    )
  }

  prepareToSaveData(event, id) {
    this.loading = true
    // this.valueEdit = jQuery('#'+inputFieldID).val();
    // console.log(event.target.id," the ID and its value ", event.target.value);
    var keyPosition = event.target.id.split('-')
    const URL = `market-info/${id}`
    this.RequestService.dash_put(URL, {
      edit_key: keyPosition[0],
      edit_position: parseInt(keyPosition[1]),
      edit_value: event.target.value,
    }).subscribe(
      (response) => {
        this.loading = false
        this.message = response.message
        this.editIsSuccess = true
        // this.openSuccessModal = true;
        this.getAllInput('all')

        // window.location.reload();
      },
      (error) => this.catchError(error)
    )
  }
  createMarketRecord(createMarketForm) {
    this.loading = true
    const form = createMarketForm
    const URL = 'market-info'
    this.newRecordInput = {
      commodity: this.selectedCropName,
      market: createMarketForm.market,
      retailprice: createMarketForm.retailprice.split('-').map((x) => +x),
      wholesaleprice: createMarketForm.wholesaleprice.split('-').map((x) => +x),
      units_of_measure: createMarketForm.units_of_measure,
    }
    // console.log(this.newRecordInput);
    this.RequestService.dash_post(URL, this.newRecordInput).subscribe(
      (response) => {
        this.loading = false
        if (response.success == true) {
          this.message = response.message
          this.marketInfo.push(response.data)
          this.addRecordSuccess = true
        } else {
          this.serverError = true
          this.message = response.message
        }
      },
      (error) => this.catchError(error)
    )
  }

  resetModal() {
    this.addRecordSuccess = false
    this.getAllInput('all')
    this.viewDetails(this.selectedCropName)
    jQuery('#addMarketInfo').modal('hide')
    // jQuery("body").addClass("modal-open");
    jQuery('#viewMore').modal('show')
    jQuery('#viewMore').css('overflow-y', 'auto')
  }
}
